<form class="payment-reason-form" [formGroup]="paymentReasonForm">
  <rkt-form
    [form]="paymentReasonForm"
    [fields]="paymentReasonFormFields"
    [model]="paymentReasonFormModel"
    (modelChange)="onPaymentReasonSelect()"
  ></rkt-form>
</form>
